/** 地址查重的兼容出口：新建表单展示候选与确认选项，CRM/签约等旧入口展示可读提示。
 * 旧页面通常直接 toast(detail)，传入结构化对象会导致 React 报错；只转换本业务错误，
 * 不改变其它错误和请求，完整候选仍保留在 error.addressConflict 供后续页面接入。
 */
export function normalizeProjectAddressConflict(error) {
  const detail = error?.response?.data?.detail;
  if (detail?.code !== "project_address_conflict") return error;
  error.addressConflict = detail;
  const path = String(error?.config?.url || "").split("?")[0].replace(/\/+$/, "");
  if (path === "/projects" || path === "/design/v3/projects") return error;
  const addresses = [...new Set((detail.candidates || []).map((p) => p.address).filter(Boolean))];
  error.response.data.detail = [detail.message, ...addresses, "请先核对原项目；如确为不同地点，请从新建项目表单确认并填写区别说明。"].join("\n");
  return error;
}
